const server = {
    state: {
        error: null,
        errorRequestID: ''
    },
    actions: {
        serverError({commit}, error) {
            commit("SET_SERVER_ERROR", error)
            commit("SET_ERROR_REQUEST_ID", error.headers['x-request-uuid'])
        }
    },
    mutations: {
        SET_SERVER_ERROR (state, error) {
            state.error = error
        },

        SET_ERROR_REQUEST_ID (state, id) {
            state.errorRequestID = id
        }
    },
    getters: {
        serverError(state) {
            return state.componentsMenu
        },

        errorRequestID(state) {
            return state.errorRequestID

        }
    }
  }

export default server;